jQuery(document).ready(function($){

  $('.price__box_wrapper').insertAfter('.castle-reviews-container');

  
  var castleVariantOptions = $('#castle-variant-options');
  var castleVariantOptionsSelections = $('#castle-variant-options .selectors');
  
  function processYmqOptions() {

    
    $('.ymq-options-box:not(.castle-fabric-swatches)').each(function(index, element) {
        var item = $(element);
        var label = item.attr('data-label');

        var imageURL = 'https://dummyimage.com/100x100/000/fff';
        switch (label){
          case 'Size':
            imageURL = 'https://www.bedchoices.co.uk/cdn/shop/t/20/assets/icon-size_1024x1024.png?v=31543344121325044601752573069';
          break;
          case 'Headboard Height':
            imageURL = 'https://www.bedchoices.co.uk/cdn/shop/t/20/assets/icon-headboard-height_1024x1024.png?v=71651354222714580451752573069';
          break;
          case 'Studs':
            imageURL = 'https://www.bedchoices.co.uk/cdn/shop/t/20/assets/icon-stud_1024x1024.png?v=86582165931147821201752573069';
          break;

          case 'Fabric':
            imageURL = 'https://www.bedchoices.co.uk/cdn/shop/t/20/assets/icon-fabric_1024x1024.png?v=32846084406414885621752573069';
          break;

          case 'Ottoman Gas Lift Storage':
            imageURL = 'https://www.bedchoices.co.uk/cdn/shop/t/20/assets/icon-ottoman-storage_1024x1024.png?v=90453762790681684271752573069';
          break;

          case 'Ottoman Storage':
          case 'Storage Option':
            imageURL = 'https://cdn.shopify.com/s/files/1/0570/0170/5607/files/Storage_Option.png?v=1752850158';
          break;

            
        }

        
        
        // var customClass = (i === 0) ? 'active' : '';

        var html = '';
        html+= `
          <div class="selector-item" data-option="${label}" data-index="${index}">
            <div class="item-image"><img alt="${label}" class="img-fluid" src="${imageURL}"/></div>
            <p>${label}</p>
          </div>
        `;
        castleVariantOptionsSelections.append(html);

        var selectorOptionsClass = (index == 0) ? 'active' : '';

        $('.castle-fabric-swatches').addClass('hide');
      
        // Get selector options
        if (label != 'Fabric'){
          var selectorOptions = '';
          selectorOptions += `<div class="selector-options ${selectorOptionsClass}" data-label="${label}">`;
          
          $(this).find('.spotlight-group label').each(function(optionIndex, optionElement) {
  
            var optionElement = $(optionElement);
            var toolTip = optionElement.find('.ymq_tooltip_show');


            
            var optionName = toolTip.html().trim(); 

            var optionTitleOnly = toolTip.clone()            // Clone the element
                  .children()              // Get the child elements (like <span>)
                  .remove()                // Remove the child elements
                  .end()                   // Go back to the cloned parent
                  .text()                  // Get only the text
                  .trim();                 // Trim extra whitespace

            
            var optionImage = optionElement.css('background-image');
            var optionID = optionElement.attr('for');
  
            optionImage = optionImage.replace(/"/g, "'");
            
            selectorOptions += `
            <div class="option" data-id="${optionID}" data-index="${index}" data-option="${optionTitleOnly}">
              <div class="image" style="background-image:${optionImage}" ></div>
              <div class="title">${optionName}</div>
            </div>`; // Use optionName
          });
          
          selectorOptions += `</div>`;
          
          $('.selectors-options').append(selectorOptions);
        }

        
    });
    

    $('.selector-item').first().addClass('active');
    
  }

  var currentIndex = 0;
  $(document).on('click','.selector-options .option',function(){


      $('.castle-total-price').remove();
    
      var optionID = $(this).attr('data-id');
      var optionIndex = $(this).attr('data-index');
      var optionTitle = $(this).attr('data-option');

      currentIndex = optionIndex;

      var parent = $(this).parents('.selector-options');
      parent.find('.option').removeClass('active');

      var label = parent.attr('data-label');

      // Update Mattress
      if (label == 'Size'){
        $('.related_main_prod_cover').hide();
        $('.related_main_prod_cover[data-title="'+optionTitle+'"]').show();
      }
      

      $(this).addClass('active');

      $('label.ymq-options-img-label[for="' +optionID+ '"]').trigger('click');

      if (currentIndex < $('.selector-options').length){

        $('.selector-item[data-index="' + currentIndex + '"]').addClass('selected'); // Add class selected
        
        currentIndex++;
        
        setTimeout(() => {
          $('.selector-item[data-index="' + currentIndex + '"]').trigger('click');
        }, 1000);
      }


      checkPriceChanges();
     
    
  });


  $(document).on('change','.quantity__input',function(){
    checkPriceChanges();
  });
  
  function checkPriceChanges(){
    
    setTimeout( () => {
        if ($('#ymq-addons-price').length && $('#ymq-addons-price').html() != ''){

          var quantity = $('.quantity__input').val();
          var additional = $('#ymq-addons-price span').attr('data-ymq-money');
          var basePrice = $('#castle-variant-options').attr('data-price');

          var total = parseInt(quantity) * (parseFloat(additional) + (parseInt(basePrice) / 100) );
          total = total.toFixed(2);

          $('.castle-total-price').remove();
          
          var totalPriceHTML = '<span class="castle-total-price"> - £' + total + '</span>';
          $('.product-form__submit').append(totalPriceHTML);
          
        }
    },1000);
  }

  $(document).on('click','.castle-fabric-swatches label',function(){
      if (currentIndex < $('.selector-options').length){

        $('.selector-item[data-index="' + currentIndex + '"]').addClass('selected'); // Add class selected
        
        currentIndex++;
        setTimeout(() => {
          $('.selector-item[data-index="' + currentIndex + '"]').trigger('click');
        }, 1000);
      }
  });
  
  function waitForYmqBox(callback) {
      const observer = new MutationObserver(function(mutations, obs) {
          if ($('#ymq-box').length) {
              obs.disconnect();
              if (typeof callback === 'function') {
                  callback();
              }
          }
      });
  
      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  }

  // Call it
  waitForYmqBox(processYmqOptions);


  
  $(document).on('click','#castle-variant-options .selectors .selector-item',function(){
      

     

      var option = $(this).attr('data-option');
      var index = $(this).attr('data-index');
      var previousIndex = index - 1;


      $('.variant-error').remove();
  

      
      // Check previous index
      var previousIndexElement = $('.selector-item[data-index="'+previousIndex+'"]');

    
      if (previousIndexElement.length || index == 0){
        if (previousIndexElement.hasClass('selected') || index == 0){

            $(this).siblings().removeClass('active');
            $(this).addClass('active');

            $('.castle-fabric-swatches').addClass('hide');

            // Selections
            $('#castle-variant-options .selector-options').removeClass('active');

          
           // Remove fabric class
            $('.ymq-options-box[data-name="properties[Fabric]"]').removeClass('active');
      
            if (option == 'Fabric'){
              $('.ymq-options-box[data-name="properties[Fabric]"]').addClass('active');
              $('.castle-fabric-swatches').removeClass('hide');


              
            }else{
              $('#castle-variant-options .selector-options[data-label="'+option+'"]').addClass('active');
            }
        }else{
          $('#castle-variant-options').prepend('<div class="variant-error">'+'Please choose ' + previousIndexElement.attr('data-option')+'</div>');
        }
      }
    

     


      

      
  });

  initSwatchDimensions(); // Castle July 2025


  function initSwatchDimensions() {
      const allowedTemplates = ['product-one-1','product-one-2','product-one-3','product-one-4'];
      const template = $('.castle-product-handle').data('template');
    
      if (allowedTemplates.includes(template)) {
        const $wrappers = $('.spb-productoptionswatchwrapper');
        const $dimensionsContents = $('.dimensions_content');

        $('.dimensions_content ul.dimensions_data + p').before(`
          <p class="dimensions-data-text">
            If Ottoman Divan Storage is selected please allow for additional 6" of width and 2-5" of length
          </p>
        `);
                
      }else{
        console.log('template not included for text')
      }
    }


  function moveAddOns() {
    var $addOns = $('.add-ons-container');

    if ($(window).width() <= 768) {
      // Mobile: Move after .castle-pay-in-terms-container
      $('.castle-pay-in-terms-container').after($addOns);
    } else {
      // Desktop: Move after .product__media_container
      $('.product__media_container').after($addOns);
    }
  }

  // Run on page load
  moveAddOns();

  // Optional: Run on window resize (debounced for performance)
  let resizeTimer;
  $(window).resize(function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(moveAddOns, 250);
  });

  
});